
/**
 * Module dependencies.
 */

import { fetchPage } from 'src/api/app/pages/fetch-page';
import { getApiPageSlugByLocale } from 'src/core/utils/routes';
import PageBuilder, { PageProps } from 'src/components/page-builder/index';
import React, { ReactElement } from 'react';

/**
 * `Props` type.
 */

type Props = {
  data: PageProps,
  slug: string
};

/**
 * `AboutUs` page.
 */

const AboutUs = (props: Props): ReactElement => (
  <PageBuilder
    {...props}
    routeName={'aboutUs'}
  />
);

/**
 * Export `getServerSideProps`.
 */

export async function getServerSideProps({ locale, query }) {
  const slug = getApiPageSlugByLocale('aboutUs', locale);
  const pageData = await fetchPage({
    hasPreview: query?.preview,
    locale,
    slug
  });

  if (!pageData) {
    return {
      notFound: true
    };
  }

  return {
    props: {
      data: pageData,
      slug
    }
  };
}

/**
 * Export `AboutUs` page.
 */

export default AboutUs;
